import { Component, HostListener } from "@angular/core";
import { CommonService } from "../shared/services/common.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as _ from "lodash";

@Component({  
  templateUrl: "./profile.component.html",
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent {

  name: string = "";
  section: number = 0;
  sectionName: string = "";

  wdthRslt: string = '19%';

  sections: Array<string> = [];
  private refreshInterval: any;

  constructor(private commonService: CommonService,
    private readonly route: ActivatedRoute,
    private readonly router: Router) {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {

    this.getName();

    this.sections = [
      "about",
      "comparecareers",
      "comparetraining",
      "jobsearchorganizer",
      "resumebuilder",
      "careerplan",
      "notes",
      "assessments",
      "employment101"
    ];

    this.sectionName = this.route.snapshot.paramMap.get("section");

    console.log("Section Name", this.route.snapshot.paramMap.get("section"));

    if (this.sectionName !== "") {
      let id = _.indexOf(this.sections, this.sectionName);
      if (id != -1) {
        this.section = id;
      }
    }

    // Set up interval to refresh data every 15 seconds
    this.refreshInterval = setInterval(() => {
      this.refreshData();
    }, 15000);
  }

  ngAfterViewChecked() {
    this.setMarginForImages();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setMarginForImages();
  }

  refreshData() {
    // Call the method to refresh data
    this.getName();
    // Add any other data refresh logic here
  }

  ngOnDestroy() {
    // Clear the interval when the component is destroyed
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

	// this is for the images to always be centered
  setMarginForImages() {

    var firstElemant = document.getElementById('firstCardImg');

    if (frameElement != null) {

      var guideCard_img_width = firstElemant.offsetWidth;
      var guideCard_width = document.getElementById('firstCard').offsetWidth;
      var remainingwidth = ((guideCard_width - guideCard_img_width) / 2).toFixed(2); //on each side of the rounded image

      var result = +(+remainingwidth / guideCard_width).toFixed(2);

      this.wdthRslt = Math.floor(result * 100) - 2 + '%';

    }
  }

  getName() {
    this.commonService.name().subscribe(name => {    
      this.name = name;
    });
  }
}
